import { render, staticRenderFns } from "./KontoTransaction.vue?vue&type=template&id=04e74935&scoped=true&"
import script from "./KontoTransaction.vue?vue&type=script&lang=js&"
export * from "./KontoTransaction.vue?vue&type=script&lang=js&"
import style0 from "./KontoTransaction.vue?vue&type=style&index=0&id=04e74935&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e74935",
  null
  
)

component.options.__file = "KontoTransaction.vue"
export default component.exports